import {CanActivate, Router} from "@angular/router";
import {inject, Injectable} from "@angular/core";
import { REPUTATION_CONFIG_TOKEN } from '../tokens';
import {map, Observable} from "rxjs";
import {toSignal} from "@angular/core/rxjs-interop";

@Injectable({ providedIn: 'root' })
export class AutoReviewAccessGuard implements CanActivate {
  private readonly reputationConfig = inject(REPUTATION_CONFIG_TOKEN);
  private readonly router = inject(Router);
  private readonly accountGroupId = toSignal(this.reputationConfig.accountGroupId$);

  canActivate(): Observable<boolean> {
    return this.reputationConfig.hasAutoReviewAccess$.pipe(
      map((hasAccess) => {
        if (!hasAccess) {
          this.router.navigateByUrl(
            '/account/location/' + this.accountGroupId() + '/home'
          );
        }
        return hasAccess;
      })
    );
  }

}
